import { Translation } from '../types';

export default  {
  // App
  appTitle: "OK Money - Simulateur de Plan de Vie",
  
  // Navigation
  navigation: {
    home: "Accueil",
    lifePlan: "Plan de Vie",
    riskSimulation: "Simulation de Risque",
    contact: "Contact",
    openMenu: "Ouvrir le Menu",
    lifePlanDescription: "Créez un plan de vie pour concevoir votre avenir",
    riskSimulationDescription: "Exécutez une simulation de risque pour évaluer les risques d'investissement",
  },

  // Home
  home: {
    hero: {
      title: "Planification de Vie Réelle par Simulation",
      subtitle: "Optimisez votre plan de vie avec des simulations qui prennent en compte l'incertitude",
      download: "Télécharger",
      docs: "Documentation"
    },
    features: {
      codeCompletion: {
        title: "Simulation en Temps Réel",
        description: "Simulez les fluctuations du marché en temps réel et proposez des plans financiers optimaux"
      },
      codebase: {
        title: "Analyse par IA",
        description: "Analysez votre portefeuille d'investissement en utilisant des données historiques et l'IA, et suggérez des améliorations"
      },
      naturalLanguage: {
        title: "Investissements qui Enrichissent votre Vie",
        description: "Faites fructifier vos actifs grâce aux investissements tout en assurant la sécurité des fonds nécessaires à la vie quotidienne"
      }
    },
  },

  // Informations de l'entreprise et conditions d'utilisation
  company: {
    title: "Informations de l'entreprise",
    basicInfo: "Informations de base",
    operatorName: "Nom de l'opérateur",
    startDate: "Date de création",
    startDateValue: "28 avril 2025",
    location: "Adresse",
    locationValue: "Yokohama, Préfecture de Kanagawa",
    contact: "Contact",
    contactForm: "Formulaire de contact",
    businessDescription: "Description de l'activité",
    businessDescriptionContent: "Fourniture de services de simulation de plan de vie",
    developerProfile: "Profil du développeur",
    developerProfileContent: "Développé par un ingénieur SIer. Avec la naissance de mon enfant, je vise à créer un service qui contribue à profiter pleinement du présent et de l'avenir lors de la planification de la vie.",
    privacyPolicy: "Politique de confidentialité",
    privacyPolicyLink: "Voir la politique de confidentialité complète",
    termsOfService: "Conditions d'utilisation",
    termsOfServiceContent: "Notre entreprise considère la protection des informations personnelles de nos clients comme une priorité absolue.",
    contentEnd: "Pour toute question, n'hésitez pas à nous contacter."
  },
  terms: {
    title: "Conditions d'utilisation",
    termsOfService: "Conditions d'utilisation",
    privacyPolicy: "Politique de confidentialité",
    article1: {
      title: "Article 1 (Application)",
      content: "Ce règlement général s'applique à tous les services (ci-après dénommés « le Service ») fournis par OKMoney (ci-après dénommé « nous » ou « nous »)."
    },
    article2: {
      title: "Article 2 (Inscription à la Service)",
      content1: "1. Pour utiliser le Service, vous devez d'abord accepter ce règlement général. Vous devrez vous inscrire en utilisant la méthode que nous avons définie.",
      content2: "2. Nous pouvons refuser l'inscription si nous déterminons, pour l'une ou l'autre des raisons suivantes, que vous ne remplissez pas les conditions d'inscription :",
      listItem1: "Si vous avez déjà été exclu de ce règlement général",
      listItem2: "Si nous déterminons que votre inscription n'est pas appropriée pour une autre raison"
    },
    article3: {
      title: "Article 3 (Interdiction)",
      content: "Vous ne devez pas effectuer les actions suivantes :",
      listItem1: "Toute action qui contrevient à la loi ou à la bonne conduite",
      listItem2: "Toute action liée à un crime",
      listItem3: "Toute action qui pourrait nuire à l'exploitation du Service",
      listItem4: "Toute action qui pourrait gêner les autres utilisateurs",
      listItem5: "Toute autre action que nous considérons comme inappropriée"
    },
    article4: {
      title: "Article 4 (Arrêt ou suspension du Service)",
      content: "Nous pouvons arrêter ou interrompre le Service en tout ou en partie, sans préavis préalable, si nous déterminons, pour l'une ou l'autre des raisons suivantes :",
      listItem1: "Si nous devons effectuer des travaux de maintenance ou de mise à jour du système informatique du Service",
      listItem2: "Si le Service ne peut être fourni en raison de forces majeures telles que des tremblements de terre, des éclairs, des incendies, des coupures d'électricité ou des catastrophes naturelles",
      listItem3: "Si nous déterminons que le Service ne peut être fourni en raison de forces majeures pour une autre raison"
    },
    article5: {
      title: "Article 5 (Décharge)",
      content: "Nous ne nous responsabilisons en aucune manière pour les transactions, les contacts ou les litiges entre vous et les autres utilisateurs ou tiers concernant le Service."
    },
    article6: {
      title: "Article 6 (Modification du Service)",
      content: "Nous pouvons modifier ou arrêter le Service sans préavis, et nous ne nous responsabilisons en aucune manière pour les dommages que cela pourrait causer à vous."
    },
    article7: {
      title: "Article 7 (Modification du Règlement général)",
      content: "Nous pouvons modifier ce règlement général à tout moment, sans préavis, si nous le déterminons nécessaire."
    },
    article8: {
      title: "Article 8 (Notification ou Contact)",
      content: "Les notifications ou contacts entre vous et nous seront effectués selon la méthode que nous avons définie."
    },
    article9: {
      title: "Article 9 (Interdiction de transférer des droits et des obligations)",
      content: "Vous ne pouvez transférer ni les droits ni les obligations que vous détenez sur le contrat d'utilisation ou ce règlement général à un tiers sans notre préalable accord écrit."
    },
    article10: {
      title: "Article 10 (Loi et juridiction compétente)",
      content1: "1. Pour interpréter ce règlement général, nous nous référons à la loi japonaise.",
      content2: "2. Si des litiges surviennent concernant le Service, nous nous référons à la juridiction exclusive d'une cour d'appel située à notre siège principal."
    },
    privacy: {
      article1: {
        title: "1. Collecte des informations personnelles",
        content: "Nous pouvons collecter les informations personnelles suivantes lors de la fourniture du Service :",
        listItem1: "Nom",
        listItem2: "Adresse e-mail",
        listItem3: "Adresse",
        listItem4: "Numéro de téléphone",
        listItem5: "Tout autre renseignement nécessaire pour fournir le Service"
      },
      article2: {
        title: "2. Utilisation des informations personnelles",
        content: "Les informations personnelles collectées seront utilisées pour les fins suivantes :",
        listItem1: "Fourniture et exploitation du Service",
        listItem2: "Réponse à vos questions",
        listItem3: "Amélioration et développement du Service",
        listItem4: "Notification d'informations importantes"
      },
      article3: {
        title: "3. Gestion des informations personnelles",
        content: "Nous mettons en œuvre des mesures de sécurité appropriées pour empêcher la fuite, la perte ou la destruction des informations personnelles."
      },
      article4: {
        title: "4. Partage des informations personnelles avec des tiers",
        content: "Nous ne partagerons pas vos informations personnelles avec des tiers, à l'exception des cas suivants :",
        listItem1: "Si vous avez donné votre consentement",
        listItem2: "Si cela est nécessaire en vertu de la loi",
        listItem3: "Si cela est nécessaire pour protéger la vie, le corps ou les biens d'une autre personne"
      },
      article5: {
        title: "5. Contact",
        content: "Pour toute question concernant la politique de confidentialité, veuillez nous contacter via le formulaire de contact."
      },
      article6: {
        title: "6. Modification de la politique de confidentialité",
        content: "Nous pouvons modifier cette politique de confidentialité si nécessaire. Nous vous informerons sur le site web."
      }
    }
  },

  // Commun
  common: {
    years: "ans",
    perYear: "/an",
    perMonth: "/mois",
    age: "Âge",
    yes: "Oui",
    no: "Non",
    none: "Aucun",
    notEntered: "Non renseigné",
    add: "Ajouter",
    delete: "Supprimer",
    save: "Enregistrer",
    cancel: "Annuler",
    reset: "Réinitialiser",
    month: "mois",
    select: "Sélectionner",
    clearSelection: "Effacer la sélection",
    dateTime: "Date et heure",
    actions: "Actions",
    currencies: {
      jpy: "Yen japonais",
      usd: "Dollar américain",
      eur: "Euro",
      gbp: "Livre sterling",
      aud: "Dollar australien",
      cad: "Dollar canadien",
      chf: "Franc suisse",
      cny: "Yuan chinois",
      hkd: "Dollar de Hong Kong",
      sgd: "Dollar de Singapour"
    },
    currency: "Devise",
    currencyHelp: "Sélectionnez la devise. La simulation sera effectuée dans la devise sélectionnée.",
    statistics: {
      title: "Statistiques",
      mean: "Moyenne",
      median: "Médiane",
      min: "Minimum",
      max: "Maximum",
      mode: "Mode",
      totalInvestment: "Investissement total",
      assetDistribution: "Distribution des actifs",
      targetAchieveRate: "Taux de réalisation de l'objectif",
      probability: "Probabilité",
      medianFinalAsset: "Actif final médian",
      finalAsset: "Actif final",
    }
  },

  // Simulation de risque
  riskSimulation: {
    title: "Simulation de risque",
    simulationSettings: "Paramètres de simulation",
    initialInvestment: "Investissement initial",
    investmentAmount: "Montant de l'investissement",
    investmentPeriod: "Période d'investissement",
    annualReturnRate: "Taux de rendement annuel",
    monthlyInvestment: "Investissement mensuel",
    volatility: "Volatilité",
    targetAmount: "Montant cible",
    runSimulation: "Lancer la simulation",
    running: "En cours",
    simulationInstruction: "Veuillez d'abord lancer la simulation.",
    noSimulationRun: "Aucune simulation exécutée",
    simulationResults: "Résultats de la simulation",
    currentResults: "Résultats actuels",
    savedResults: "Résultats sauvegardés",
    compare: "Comparer",
    resultTitle: "Résultats de la simulation de risque",
    simulationConditions: "Conditions de simulation",
    saveSimulationResult: "Sauvegarder les résultats de la simulation",
    saveSimulationDescription: "Veuillez entrer un nom pour les résultats de la simulation.",
    simulationName: "Nom de la simulation",
    simulationNamePlaceholder: "Entrez le nom des résultats de la simulation",
    saveSimulation: "Sauvegarder la simulation",
    noSavedSimulations: "Aucune simulation sauvegardée",
    noSavedSimulationsDescription: "Aucune simulation sauvegardée trouvée. Veuillez d'abord exécuter une simulation.",
    createNewSimulation: "Créer une nouvelle simulation",
    selectSimulationsToCompare: "Sélectionner les simulations à comparer",
    noSelectedSimulations: "Aucune simulation sélectionnée",
    selectTwoOrMoreSimulations: "Veuillez sélectionner deux simulations ou plus.",
    comparisonResults: "Résultats de la comparaison",
    finalAssetComparison: "Comparaison des actifs finaux",
    finalAssetComparisonDescription: "Comparaison des actifs finaux des simulations",
    successRateComparison: "Comparaison des taux de réussite",
    successRateComparisonDescription: "Comparaison des taux de réussite des simulations",
    simulationParameters: "Paramètres de simulation",
    simulationParametersDescription: "Comparaison des paramètres de simulation",
    period: "Période",
    successRate: "Taux de réussite",
    backToSimulation: "Retour à la simulation",
  },

  // Plan de vie
  lifePlan: {
    title: "Création du plan de vie",
    resultTitle: "Résultats de la simulation du plan de vie",
    steps: {
      basicInfo: "Informations de base",
      incomeExpense: "Revenus et dépenses",
      assetsLiabilities: "Actifs et passifs",
      lifeGoals: "Événements de vie",
      simulationSettings: "Paramètres de simulation",
      confirmation: "Confirmation",
    },
    navigation: {
      prev: "Précédent",
      next: "Suivant",
      startSimulation: "Démarrer la simulation",
      confirmStart: "Voulez-vous démarrer la simulation ?",
      confirmStartTitle: "Confirmation du Démarrage de la Simulation",
      cancel: "Annuler",
    },
    basicInfo: {
      title: "Informations de base",
      name: "Nom",
      namePlaceholder: "Entrez votre nom",
      age: "Âge",
      gender: {
        title: "Genre",
        male: "Homme",
        female: "Femme",
        other: "Autre",
      },
      familyStructure: {
        title: "Structure familiale",
        hasSpouse: "Avec conjoint",
        spouseAge: "Âge du conjoint",
        children: "Enfants",
        help: "Entrez la structure familiale",
        childrenHelp: "Entrez l'âge des enfants",
        addChild: "Ajouter un enfant",
        removeChild: "Supprimer un enfant",
        noChildren: "Pas d'enfants",
      },
      spouse: "Conjoint",
      children: "Enfants"
    },
    incomeExpense: {
      title: "Revenus et dépenses",
      income: {
        title: "Revenus",
        annualIncome: "Revenu annuel (10,000 €)",
        salaryIncreaseRate: "Taux d'augmentation (%)",
        annualBonus: "Prime annuelle (10,000 €)",
      },
      expense: {
        title: "Dépenses",
        help: "Entrez les dépenses mensuelles",
        housingCost: "Frais de logement (10,000 €/mois)",
        housingCostHelp: "Entrez le loyer mensuel ou le remboursement du prêt",
        utilities: "Services publics (10,000 €/mois)",
        food: "Alimentation (10,000 €/mois)",
        communication: "Télécommunications (10,000 €/mois)",
        transportation: "Transport (10,000 €/mois)",
        entertainment: "Loisirs (10,000 €/mois)",
        investment: "Investissement (10,000 €/mois)",
        stocks: "Actions (10,000 €/mois)",
        bonds: "Obligations (10,000 €/mois)",
        mutualFunds: "Fonds communs (10,000 €/mois)",
        insurance: "Assurance (10,000 €/mois)",
        other: "Autres (10,000 €/mois)"
      },
      annualIncome: "Revenu annuel",
      salaryIncreaseRate: "Taux d'augmentation",
      annualBonus: "Prime annuelle",
      housingCost: "Frais de logement",
      utilities: "Services publics",
      food: "Alimentation",
      communication: "Télécommunications",
      transportation: "Transport",
      entertainment: "Loisirs",
      other: "Autres"
    },
    assetsLiabilities: {
      title: "Actifs et passifs",
      assets: {
        title: "Actifs",
        savings: "Épargne",
        stocks: "Actions",
        bonds: "Obligations",
        mutualFunds: "Fonds communs",
        insurance: "Assurance",
        other: "Autres",
        amount: "Montant (10,000 €)",
        return: "Rendement attendu (%)",
        volatility: "Volatilité (%)",
        investmentAssets: "Actifs d'investissement",
      },
      liabilities: {
        title: "Passifs",
        housingLoan: "Prêt immobilier",
        carLoan: "Prêt automobile",
        otherLoans: "Autres prêts",
        addLoan: "Ajouter un prêt",
        removeLoan: "Supprimer un prêt",
        name: "Nom du prêt",
        amount: "Montant du prêt (10,000 €)",
        period: "Durée de remboursement (ans)",
        interestRate: "Taux d'intérêt (%)",
        noLoans: "Aucun Prêt",
      },
      savings: "Épargne",
      stocks: "Actions",
      bonds: "Obligations",
      mutualFunds: "Fonds communs",
      insurance: "Assurance",
      otherInvestments: "Autres investissements",
      housingLoanBalance: "Solde du Prêt Immobilier",
      housingLoanPeriod: "Durée du Prêt",
      housingLoanInterest: "Taux d'Intérêt",
      noLoans: "Aucun Prêt",
      otherLoans: "Autres prêts"
    },
    lifeGoals: {
      title: "Événements de vie",
      housingPurchase: "Achat immobilier",
      educationFunds: "Fonds d'éducation",
      child: "Enfant",
      otherGoals: "Autres objectifs",
      retirementAge: "Âge de la retraite",
      retirementMonthlyExpense: "Dépenses mensuelles à la retraite",
      notPlanned: "Non planifié",
      housing: {
        title: "Achat immobilier",
        planned: "Achat prévu",
        year: "Année d'achat prévue",
        amount: "Montant prévu (10,000 €)",
        purchaseAmount: "Montant d'achat (10,000 €)",
        purchaseYear: "Année d'achat",
      },
      education: {
        title: "Plan de fonds d'éducation",
        subtitle: "Planification des fonds d'éducation",
        add: "Ajouter un fonds d'éducation",
        remove: "Supprimer le fonds d'éducation",
        name: "Nom du fonds d'éducation",
        namePlaceholder: "Entrez le nom du fonds d'éducation",
        childAge: "Âge de l'enfant",
        age: "Âge requis",
        amount: "Montant requis",
        requiredAmount: "Montant requis",
        noData: "Aucun fonds d'éducation ajouté",
      },
      other: {
        title: "Autres objectifs",
        subtitle: "Autres événements de vie",
        add: "Ajouter un objectif",
        remove: "Supprimer un objectif",
        name: "Nom de l'objectif",
        year: "Année de l'objectif",
        amount: "Montant requis (10,000 €)",
        noData: "Aucun objectif",
        namePlaceholder: "Entrez le nom de l'autre objectif",
        plannedAge: "Âge prévu",
        requiredAmount: "Montant requis"
      },
      retirement: {
        title: "Plan de retraite",
        age: "Âge de retraite prévu",
        monthlyExpense: "Dépenses mensuelles à la retraite (10,000 €)",
      },
    },
    simulationSettings: {
      title: "Paramètres de simulation",
      inflationRate: "Taux d'inflation (%)",
      investmentReturn: "Rendement de l'investissement (%)",
      simulationPeriod: "Période de simulation (ans)",
      currency: "Devise",
      currencyHelp: "Sélectionnez la devise. La simulation sera effectuée dans la devise sélectionnée.",
      inflationRateHelp: "Simulation tenant compte du taux d'inflation futur."
    },
    runningSimulation: "Simulation en cours",
    result: {
      title: "Résultats de la simulation du plan de vie",
      settings: "Paramètres du plan de vie",
      planSettings: "Paramètres du plan",
      actions: {
        print: "Imprimer",
        downloadCSV: "Télécharger CSV",
        modifyConditions: "Modifier les conditions",
        backToInput: "Retour à la saisie",
      },
      tabs: {
        charts: "Graphiques",
        details: "Détails",
        analysis: "Analyse et recommandations",
      },
      charts: {
        assetIncomeExpense: "Évolution des actifs et des flux",
        agePoint: "À {age} ans",
        spouse: "Conjoint : {age} ans",
        children: "Enfants",
        age: "{age} ans",
        assets: "Actifs",
        liabilities: "Passifs",
        netWorth: "Valeur nette",
        amount: "Montant (10,000 €)",
        noData: "Aucune donnée",
        assetTrend: "Tendance des actifs",
        incomeExpenseTrend: "Tendance des flux",
        income: "Revenus",
        expense: "Dépenses",
        savings: "Épargne",
      },
      details: {
        yearlyData: "Détails des données annuelles",
      },
      analysis: {
        risk: "Analyse des risques",
        recommendations: "Recommandations d'amélioration",
      },
      table: {
        search: "Rechercher...",
        age: "Âge",
        familyAge: "Âge de la famille",
        income: "Revenus",
        expense: "Dépenses",
        savings: "Épargne",
        assets: "Solde des actifs",
        lifeEvents: "Événements de vie",
        ageValue: "{age} ans",
        spouse: "Conjoint : {age} ans",
        children: "Enfants",
        amount: "10,000 €",
        noData: "Aucune donnée",
      },
      timeline: {
        age: "Âge",
        event: "Événement",
        retirement: "Retraite",
        ageValue: "{age} ans",
        agePoint: "À {age} ans",
        spouse: "Conjoint : {age} ans",
        children: "Enfants",
        neededAmount: "Montant requis : {amount}",
        assets: "Actifs : {amount}",
        education: "{fundName} de {childName}",
        child: "Enfant",
        educationFund: "Fonds d'éducation"
      },
      summary: {
        title: "Résumé",
        monthlyIncome: "Revenus mensuels",
        monthlyExpense: "Dépenses mensuelles",
        monthlyInvestment: "Investissement mensuel",
        monthlySavings: "Épargne mensuelle",
        totalAssets: "Total des actifs",
        totalLiabilities: "Total des passifs",
        netWorth: "Valeur nette",
        finalAssets: "Actifs finaux",
        peakAssets: "Actifs au pic",
        retirementAssets: "Actifs à la retraite",
        savingsRate: "Taux d'épargne",
        savingsRateDesc: "Proportion de l'épargne par rapport aux revenus",
        retirementBalance: "Solde à la retraite",
        balance: "Solde",
        riskAssessment: "Évaluation des risques",
        riskLow: "Risque faible",
        riskMedium: "Risque moyen",
        riskHigh: "Risque élevé",
        negativeAssets: "Il y aura des périodes où les actifs seront négatifs à l'avenir.",
        positiveAssets: "Les actifs devraient rester positifs en permanence.",
        needImprovement: "Des améliorations des revenus et des dépenses sont nécessaires.",
        unit: "10,000 €",
        atAge: "À {age} ans",
      },
      chart: {
        title: "Aperçu de l'évolution des actifs",
        noData: "Veuillez saisir des données",
        assets: "Actifs",
        income: "Revenus",
        expense: "Dépenses",
      },
    },
    confirmation: {
      title: "Confirmation"
    },
    validation: {
      error: "Il y a une erreur dans la saisie."
    },
  },
  login: "Connexion",
  register: "Inscription",
  loginDescription: "Vous n'avez pas de compte ? Veuillez vous inscrire.",
  registerDescription: "Créez un compte pour commencer votre simulation de plan de vie.",
  email: "E-mail",
  password: "Mot de passe",
  passwordRequirements: "Le mot de passe doit contenir au moins 8 caractères et inclure des lettres et des chiffres.",
  loggingIn: "Connexion en cours...",
  registering: "Inscription en cours...",
  loginFailed: "Échec de la connexion.",
  registrationSuccess: "Inscription terminée.",
  registrationFailed: "Échec de l'inscription.",
  myPage: "Mon Compte",
  logout: "Déconnexion",
  userProfile: "Profil Utilisateur",
  userProfileDescription: "Gérer vos informations de profil",
  savedSimulations: "Simulations Sauvegardées",
  savedSimulationsDescription: "Liste de vos résultats de simulation sauvegardés",
  settings: "Paramètres",
  accountSettings: "Paramètres du compte",
  accountSettingsDescription: "Gérer les paramètres de votre compte",
  changePassword: "Changer le mot de passe",
  changePasswordDescription: "Modifier votre mot de passe",
} as Translation; 